import React, { useEffect, useState } from 'react';
import {
  CustomTabModal,
} from './SbModel';

interface CustomTabsProps {
  tabs: CustomTabModal[];
  tabSelected: number;
  tabSelectHandler: (id: number) => void;
}

const CustomTabs: React.FC<CustomTabsProps> = ({ tabs, tabSelected, tabSelectHandler }) => {
  // const [tabSelected, setTabSelected] = useState<number>(1);
  const [tabsList, settabsList] = useState([]);

  useEffect(() => {
    settabsList(tabs);
  }, [tabs])
  return (
    <>
      {tabsList.map((item, index) => {
        if(!item.show) {
          return <></>;
        }
        return (
          <div
            key={index}
            onClick={() => {
              // setTabSelected(item.id);
              tabSelectHandler(item.id);
            }}
            className={
              'cursor-pointer flex py-4 px-6 text-center ' +
              (tabSelected == item.id ? 'border-b-2 border-blue-500 text-blue-500' : '')
            }
          >
            {item.name}
          </div>
        );
      })}
    </>
  );
};

export default CustomTabs;
